import { bookingsApi } from '~/api';

const actionPrefix = (actionType) => `CompletePage/${actionType}`;

export const SET_BOOKING_COMPLETED = actionPrefix`SET_BOOKING_COMPLETED`;
export const setBookingCompleted = (isBookingCompleted) => ({
  type: SET_BOOKING_COMPLETED,
  payload: isBookingCompleted,
});

export const SET_BOOKING = actionPrefix`SET_BOOKING`;
export const setBooking = (bookingId) => (dispatch) =>
  bookingsApi.getBooking(bookingId).then((booking) => {
    dispatch({
      type: SET_BOOKING,
      payload: booking,
    });
    return booking;
  });

export const bookingsActions = {
  setBooking,
  setBookingCompleted,
};
